<div id="scrollable-container" #scrollable>

  <div *ngFor="let value, index as idx of qrCodeMeasuresForDisplay">
    <app-qr-code-time-card [hourAndUnit]="formatCardHours(value.date, value.timezone)" [idx]="idx"
      [healthIdx]="value.health_idx" [date]="value.date">
    </app-qr-code-time-card>
  </div>
</div>
